/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import React from 'react';

/**
 * MaterialRounded Timer off icon.
 * @export
 */
export const ICON_TIMER_OFF = (
  <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
    <path d="M15.7101 1.19495H9.7101V3.19495H15.7101V1.19495Z" fill="#949494" />
    <path
      d="M12.7101 6.19495C16.5801 6.19495 19.7101 9.32495 19.7101 13.1949C19.7101 14.1349 19.5201 15.0249 19.1901 15.8449L20.6901 17.3449C21.3401 16.1049 21.7101 14.6949 21.7101 13.1949C21.7101 11.0749 20.9701 9.12495 19.7401 7.58495L21.1601 6.16495C20.7301 5.65495 20.2601 5.17495 19.7501 4.75495L18.3301 6.17495C16.7801 4.93495 14.8301 4.19495 12.7101 4.19495C11.2101 4.19495 9.8001 4.56495 8.5601 5.21495L10.0601 6.71495C10.8801 6.38495 11.7701 6.19495 12.7101 6.19495Z"
      fill="#949494"
    />
    <path d="M11.7101 8.36495L13.7101 10.3649V8.19495H11.7101V8.36495Z" fill="#949494" />
    <path
      d="M3.5201 3.00495L2.1001 4.41495L5.5001 7.81495C4.3801 9.31495 3.7101 11.1749 3.7101 13.1949C3.7101 18.1649 7.7301 22.1949 12.7101 22.1949C14.7301 22.1949 16.5901 21.5249 18.0901 20.4049L20.4901 22.8049L21.9001 21.3949L3.5201 3.00495ZM12.7101 20.1949C8.8401 20.1949 5.7101 17.0649 5.7101 13.1949C5.7101 11.7249 6.1601 10.3649 6.9301 9.24495L16.6601 18.9749C15.5401 19.7449 14.1801 20.1949 12.7101 20.1949Z"
      fill="#949494"
    />
  </svg>
);
